module.exports = __webpack_public_path__ + "static/media/image4-2.d41ab415.jpg";